import { useRef } from 'react';

import { useModal } from 'mui-modal-provider';

import {
  EnableCastFeaturesDialog,
  EnableCastFeaturesDialogProps,
} from './EnableCastFeaturesDialog';

import { ShowModalOutput } from '@cast/design-system';

export const useEnableCastFeaturesDialog = () => {
  const modalInstance = useRef<ShowModalOutput>(undefined);
  const { showModal } = useModal({ disableAutoDestroy: true });

  return {
    openEnableCastFeaturesDialog: ({
      filterClusterList = true,
      shouldNavigateOnSuccess = true,
      onSuccess,
    }: EnableCastFeaturesDialogProps = {}) => {
      modalInstance.current = showModal(EnableCastFeaturesDialog, {
        filterClusterList,
        shouldNavigateOnSuccess,
        onSuccess,
        onClose: () => modalInstance.current?.destroy(),
      });
    },
  };
};
